var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delivery",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 48,
    viewBox: "0 0 65 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_161553",
    "data-name": "Rectangle 161553",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 47,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_175830",
    "data-name": "Group 175830",
    transform: "translate(3.22 4.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175826",
    "data-name": "Group 175826",
    transform: "translate(0 2.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175825",
    "data-name": "Group 175825",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38313",
    "data-name": "Path 38313",
    d: "M1560.06,238.227a.968.968,0,0,1-.684-.282l-2.916-2.894a.971.971,0,0,1,1.368-1.378l2.227,2.21,11.775-11.867-5.457-5.441a.971.971,0,0,1,1.371-1.375l6.143,6.124a.971.971,0,0,1,0,1.371l-13.141,13.244A.968.968,0,0,1,1560.06,238.227Z",
    transform: "translate(-1556.173 -216.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_175822",
    "data-name": "Group 175822",
    transform: "translate(4.511 17.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38314",
    "data-name": "Path 38314",
    d: "M1594.625,333.987a3.238,3.238,0,0,1-2.273-.934l-4.013-3.947a15.961,15.961,0,0,1-4.478-8.508l-.382-2.105-2.194-2.182a.971.971,0,1,1,1.369-1.377l2.411,2.4a.97.97,0,0,1,.271.515l.437,2.406a14.013,14.013,0,0,0,3.93,7.471l4.013,3.947a1.287,1.287,0,0,0,1.908-.1,1.351,1.351,0,0,0-.167-1.785l-.838-.836-.226-.2a.971.971,0,1,1,1.291-1.45l.246.219.04.038.856.853a3.308,3.308,0,0,1,.3,4.391,3.248,3.248,0,0,1-2.336,1.184C1594.735,333.985,1594.68,333.987,1594.625,333.987Z",
    transform: "translate(-1580.999 -314.652)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175823",
    "data-name": "Group 175823",
    transform: "translate(18.369 29.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38315",
    "data-name": "Path 38315",
    d: "M1663.461,388.848a3.2,3.2,0,0,1-2.269-.934l-3.641-3.615a.971.971,0,0,1,1.368-1.378l3.641,3.615a1.271,1.271,0,0,0,.9.37h.005a1.278,1.278,0,0,0,.9-2.187l-.173-.172-.8-.773-.011-.011-.456-.452a.971.971,0,1,1,1.368-1.378l.45.447.8.772.011.011.177.176a3.221,3.221,0,0,1-2.258,5.508Z",
    transform: "translate(-1657.265 -381.652)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175824",
    "data-name": "Group 175824",
    transform: "translate(25.377 29.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38316",
    "data-name": "Path 38316",
    d: "M1701.159,386.724a3.22,3.22,0,0,1-2.265-.924l-.147-.142a.971.971,0,0,1-.078-.069l-2.55-2.519a.971.971,0,1,1,1.365-1.381l2.367,2.338.041.037.354.342.008.008a1.292,1.292,0,0,0,1.819-.007,1.263,1.263,0,0,0,.362-1s0,0,0-.007a1.247,1.247,0,0,0-.362-.794l-1.655-1.574a.971.971,0,1,1,1.338-1.407l1.662,1.581.01.01a3.218,3.218,0,0,1-2.268,5.509Z",
    transform: "translate(-1695.83 -379.357)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38317",
    "data-name": "Path 38317",
    d: "M1658.534,287.99a3.366,3.366,0,0,1-2.371-.989l-2.638-2.593a.971.971,0,1,1,1.361-1.385l2.642,2.6a1.351,1.351,0,0,0,1.762.172,1.287,1.287,0,0,0,.488-.943,1.27,1.27,0,0,0-.379-.979l-11.271-11.192a2.383,2.383,0,0,1,3.076-3.622l2.616,1.886a2.476,2.476,0,0,0,3.515-.648.189.189,0,0,0,.028-.087.2.2,0,0,0-.083-.184l-9.263-6.168a6.794,6.794,0,0,0-5.74-.852l-2.066.621a.971.971,0,0,1-.963-.24l-2.739-2.714a.971.971,0,1,1,1.366-1.379l2.329,2.308,1.512-.455a8.729,8.729,0,0,1,7.375,1.094l9.263,6.168a2.147,2.147,0,0,1,.6,2.954,4.418,4.418,0,0,1-6.272,1.158l-2.621-1.889a.426.426,0,0,0-.213-.085.451.451,0,0,0-.375.144.444.444,0,0,0,.019.613l11.27,11.191a3.227,3.227,0,0,1-.266,4.818A3.152,3.152,0,0,1,1658.534,287.99Z",
    transform: "translate(-1621.675 -251.661)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175829",
    "data-name": "Group 175829",
    transform: "translate(19.15 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175827",
    "data-name": "Group 175827",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38318",
    "data-name": "Path 38318",
    d: "M1704.372,239.109h-14.265a.963.963,0,1,1,0-1.926H1703.4V202.821H1669.06V209.9a.971.971,0,0,1-1.941,0v-8.046a.967.967,0,0,1,.971-.963h36.282a.967.967,0,0,1,.971.963v36.288A.967.967,0,0,1,1704.372,239.109Z",
    transform: "translate(-1667.118 -200.895)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175828",
    "data-name": "Group 175828",
    transform: "translate(24.956 31.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_36",
    "data-name": "Line 36",
    d: "M1.111,1.191H.221a.971.971,0,1,1,0-1.941h.89a.971.971,0,1,1,0,1.941Z",
    transform: "translate(0.75 0.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M1.111,1.191H.221a.971.971,0,1,1,0-1.941h.89a.971.971,0,1,1,0,1.941Z",
    transform: "translate(5.783 0.75)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38319",
    "data-name": "Path 38319",
    d: "M1747.514,211.955a.97.97,0,0,1-.487-.131l-4.716-2.737-4.716,2.737a.971.971,0,0,1-1.458-.84v-9.118a.971.971,0,0,1,1.941,0V209.3l3.745-2.174a.971.971,0,0,1,.975,0l3.745,2.174v-7.433a.971.971,0,0,1,1.942,0v9.118a.971.971,0,0,1-.971.971Z",
    transform: "translate(-1704.153 -200.895)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.9174a9849c0cceaa09ccca9726324320.svg";
export { ForwardRef as ReactComponent };